import PropTypes from 'prop-types';

const PanelPaddingBuster = ({ children }) => (
  <div className="-mr-4 -ml-4 negate-padding-regular">{children}</div>
);

PanelPaddingBuster.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PanelPaddingBuster;
